// extracted by mini-css-extract-plugin
export default {"sider__header":"SaveTemplateDrawer_sider__header__zVU3v","sider__header__left":"SaveTemplateDrawer_sider__header__left__l0CuT","sider__body":"SaveTemplateDrawer_sider__body__yvKZw"};